import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/common/modal'
import StandardError from 'components/common/standard_error'
import { getI18n } from 'client/i18n'
import { exitGlimpse } from 'lib/glimpse'
import { getMoneyPoolTNCLink } from 'lib/global'
import { routerShape } from 'react-router/lib/PropTypes'
import { Button } from '@paypalcorp/pp-react'
import { glimpseRoute } from 'lib/route_utils'
import { Link } from 'react-router'
import JsxParser from 'react-jsx-parser'
import { baseUrl } from 'shared/campaign_url'

const i18n = getI18n('components/pages/create/create')

class CountryBlocked extends React.Component {
  static propTypes = {
    countryName: PropTypes.string,
    countryCode: PropTypes.string,
    showClose: PropTypes.bool,
    router: routerShape.isRequired,
    money_pool_creation_blocked: PropTypes.bool,
    crowdfunding_enabled: PropTypes.bool,
    paypalDomain: PropTypes.string,
  }

  static defaultProps = {
    showClose: false,
  }

  handleClose = () => {
    exitGlimpse('send', this.props.router)
  }

  render() {
    const {
      money_pool_creation_blocked,
      crowdfunding_enabled,
      paypalDomain,
      countryCode,
    } = this.props
    let titleJSX = i18n('moneypool_blocked_title', {
      tc_link: getMoneyPoolTNCLink(paypalDomain, countryCode),
    })

    const title = money_pool_creation_blocked ? (
      <JsxParser jsx={typeof titleJSX === 'string' ? titleJSX : ''} />
    ) : (
      i18n('blocked_title')
    )

    const subtitle = money_pool_creation_blocked
      ? ''
      : i18n('blocked_subtitle', { country: this.props.countryName })
    let button = null
    if (money_pool_creation_blocked && !crowdfunding_enabled) {
      button = (
        <Button
          as="a"
          href={baseUrl(location.hostname, '/myaccount/summary')}
          role="button"
          secondary
        >
          {i18n('go_to_account_summary_cta')}
        </Button>
      )
    } else if (money_pool_creation_blocked && crowdfunding_enabled) {
      button = (
        <Button as={Link} to={glimpseRoute('create', 'types')}>
          {i18n('start_gn_cta')}
        </Button>
      )
    }
    return (
      <Modal
        glimpse={true}
        onClose={this.handleClose}
        showClose={this.props.showClose}
      >
        <StandardError
          iconType="warning"
          title={title}
          subtitle={subtitle}
          showButton={false}
          extraContent={button}
        />
      </Modal>
    )
  }
}
export default CountryBlocked
